module.exports = __webpack_public_path__ + "static/media/cold.3e9e085a.jpg";